import React, { useEffect, useRef, useState } from "react";
import Loaders from "../Loaders";
import HeaderTop from "../HeaderTop";
import Menus from "../Menus";
import Footers from "../Footers";
import '../../../libs/css/bootstrap.min3.3.7.css';
import '../../../libs/css/sweetalert2.min.css';
import { API_ROUTES } from "../../../utils/constants";
import Nulls from "../Nulls";
import ChargingSyncTable from "./ChargingSyncTable";
import { format } from "date-fns";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";


export default function ChargingSync(props){
    const {objectToFormData, errorFunction, Helmet, capitalizeWords, isAuthExpired } = props;

    useEffect(() => {document.title = "Charging SYNC | Forthsoft"}, []);

    const [isLoading, setIsLoading] = useState(true);
    const [dataTotal, setDataTotal] = useState(0);
    const [dataList, setDataList] = useState([]);
    const [columns, setColumns] = useState([]);
    const [page, setPage] = useState(1);
    const countPerPage = 20;
    const [isFade, setIsFade] = useState(true);
    const [openBearerID, setOpenBearerID] = useState(false);
    const [openService, setOpenService] = useState(true);
    const [openNtwk, setOpenNtwk] = useState(false);
    const [registerName, setRegisterName] = useState('service');
    const clearInputs = useRef(null);


    const columns1 = [
        {   
            name: 'Service Type',
            selector: row => row.serviceType ? row.serviceType : <Nulls />,
            sortable: true,
        },
        {
            name: 'Calling Party',
            selector: row => row.callingParty ? row.callingParty : <Nulls />,
            sortable: true,
        },
        {   
            name: 'Network',
            cell: row => {
                let isNetwork = <div style={{ color:'orange' }}>MTN</div>
                if(row.network_id === 2){
                    isNetwork = <div style={{ color:'#72ae49' }}>GLO</div>
                }else if(row.network_id === 3){
                    isNetwork = <div style={{ color:'red' }}>AIRTEL</div>
                }else if(row.network_id === 4){
                    isNetwork = <div style={{ color:'#82AA40' }}>9MOBILE</div>
                }
                return <b>{isNetwork}</b>
            },
        },
        {
            name: 'Amount',
            selector: row => row.chargeAmount ? '₦'+parseFloat(row.chargeAmount).toLocaleString() : '0.00',
        },
        {
            name: 'Status',
            cell: row => {
                let isStatus = <div style={{ color:'orange' }}>Pending</div>
                if(row.status === 1){
                    isStatus = <div style={{ color:'red' }}>Failed</div>
                }else if(row.status === 2){
                    isStatus = <div style={{ color:'green' }}>Completed</div>
                }
                return isStatus;
            }
        },
        {
            name: 'Service Node',
            selector: row => row.serviceNode ? row.serviceNode : <Nulls />,
        },
        {
            name: 'Validity (Days)',
            selector: row => row.validityDays + " days",
        },
        {
            name: 'Date Created',
            selector: row => {
                return row.created_at ? format(new Date(row.created_at), "MMM d, yyyy h:mma") : <Nulls />;
            }
        },
    ];
    useEffect(() => {
        setColumns(columns1);
    }, []);

    const userData = JSON.parse(localStorage.getItem('userDataFs'));

    const getData = async (isLoad=true, myFilters={}) => {
        let url = "";
        // url = `${API_ROUTES.VIEW_SERVICES}?page=${page}&perPage=${countPerPage}`;
        // if(network !== null || keyword !== null){
        //     url = `${API_ROUTES.VIEW_SERVICES}?page=${page}&perPage=${countPerPage}&network=${network}&keyword=${keyword}&price_point=${price_point}`;
        // }

        // url = `${API_ROUTES.VIEW_SERVICES}`;
        // if(network !== null || keyword !== null){
        //     url = `${API_ROUTES.VIEW_SERVICES}?network=${network}&keyword=${keyword}&price_point=${price_point}`;
        // }

        let dataString2 = {};

        const dataString1 = { 
            page: page,
        };

        if(registerName === "service"){
            dataString2 = { 
                service: myFilters.service,
            } 
        }else if(registerName === "network"){
            dataString2 = { 
                network: myFilters,
            } 
        }else if(registerName === "bearerId"){
            dataString2 = { 
                bearerId: myFilters.bearerId,
            }
        }
        const mergedObject = { ...dataString1, ...dataString2 };
        setIsFade(true);

        try {
            const response = await fetch(API_ROUTES.CHARGING_SYNC, {
                method: "POST",
                body: objectToFormData(mergedObject),
                headers: {'token': userData?.responseDetails?.token},
            });
            const responseJSON = await response.json();
            isAuthExpired(responseJSON); // check for expired login

            if (responseJSON.status.toString() === "200") {
                const responseData = responseJSON.data;
                const totalData = responseData.length;
                setDataTotal(totalData);
                setDataList(responseData.slice(0,20));
                setIsLoading(false);
                setIsFade(false);
            }else{
                setDataTotal(0);
                setDataList([]);
                setIsLoading(false);
                setIsFade(false);
            }
        } catch (error) {
            console.log('Error getting data: ', error);
            setDataTotal(0);
            setDataList([]);
            setIsLoading(false);
            setIsFade(false);
        }
    }

    useEffect(() => {
        getData(true, "");
    }, [page]);

    const handleChanges = async (event) => {
        const filters = event.target.value;
    }

    const handleNetworkChange = async (event) => {
        const filters = event.target.value;
        getData(true, filters);
    }
    
    const handleAllNetworks = async (event) => {
        const filters = event.target.value;
    }
    
    const handleNtwks = async (data) => {
        getData(true, data);
    }
    
    const handleOthers = async (data) => {
        getData(true, data);
    }
    
    const handleBearerID = async (data) => {
        console.log(data);
        getData(true, data);
    }

    const handleFilters = async (event) => {
        const filters = event.target.value;
        setDataTotal(0);
        setDataList([]);

        setRegisterName(filters);

        setOpenNtwk(false);
        setOpenService(false);
        setOpenBearerID(false);
        
        if(filters === "bearerId"){
            setOpenBearerID(true);
        }
        if(filters === "service"){
            setOpenService(true);
        }
        if(filters === "network"){
            setOpenNtwk(true);
        }
    }

    const handleOthersChange = async (event) => {
        const filters = event.target.value;
        let datas = {};

        if(registerName === "service"){
            datas = {service: filters}
        }else if(registerName === "network"){
            datas = {network: filters}
        }else if(registerName === "subscriber_address"){
            datas = {subscriber_address: filters}
        }else if(registerName === "channel"){
            datas = {channel: filters}
        }
        getData(true, datas);
    }


    return (
        <>
            {/* <Loaders /> */}
            {/* <LoadingSpinner /> */}

            <div className="flapt-page-wrapper mainContent">
                <Menus />

                <div className="flapt-page-content">
                    <HeaderTop />

                    <div className="main-content introduction-farm mt--20">
                        <div className="content-wraper-area">
                            <div className="dashboard-area">
                                <div className="container-fluid mb-90">
                                    <div className="row g-4">
                                        <div className="col-lg-12 pl-xs-0 pr-xs-0">
                                            <div className="card-header mb--20 mb-xs-10">
                                                <h2>Charging SYNC</h2>
                                            </div>

                                            <ChargingSyncTable capitalizeWords={capitalizeWords} dataList={dataList} dataTotal={dataTotal} isLoading={isLoading} columns={columns} countPerPage={countPerPage} setPage={setPage} handleChanges={handleChanges} isFade={isFade} handleFilters={handleFilters} openBearerID={openBearerID} openService={openService} openNtwk={openNtwk} handleNtwks={handleNtwks} handleAllNetworks={handleAllNetworks} handleNetworkChange={handleNetworkChange} handleBearerID={handleBearerID} handleOthers={handleOthers} registerName={registerName} handleOthersChange={handleOthersChange} clearInputs={clearInputs} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footers />
                    </div>
                </div>
            </div>
        </>
    );
}